import commonActions from '../../actions/common.actions'
import { StrategyTemplateProto, StrategyTemplatesProto } from '../../proto/generated/strategy'
import { addOrUpdateStrategy, removeStrategyTemplate, setStrategyTemplates } from '../../reducer/strategyTemplates.reducer'
import store from '../../store'
import api from './axiosClient'

export const fetchStrategyTemplates = (): Promise<StrategyTemplatesProto> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/strategy`
        api.request({
            url: url,
            headers: {
                Accept: 'application/x-protobuf'
            },
            method: 'GET',
            responseType: 'arraybuffer',
            data: {}
        })
            .then(async (response) => {
                const result = StrategyTemplatesProto.decode(new Uint8Array(response.data))
                store.dispatch(setStrategyTemplates(result.strategyTemplates))
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const createStrategyTemplate = (args: { body: StrategyTemplateProto }): Promise<StrategyTemplateProto> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/strategy`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = StrategyTemplateProto.decode(new Uint8Array(response.data))
                if(response.status===200) {
                    store.dispatch(addOrUpdateStrategy(args.body))
                    commonActions.setApiError(store.dispatch, { error: true, message: 'Template saved successfully', errorType: 'success'})
                }
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const modifyStrategyTemplate = (args: { request: StrategyTemplateProto }): Promise<StrategyTemplateProto> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/strategy/modify`
        api.post(url, JSON.stringify(args.request), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = StrategyTemplateProto.decode(new Uint8Array(response.data))
                if(response.status===200) {
                    store.dispatch(addOrUpdateStrategy(args.request))
                    commonActions.setApiError(store.dispatch, { error: true, message: 'Template updated successfully', errorType: 'success'})
                }
                resolve(result)
               })
            .catch((error) => {
                reject(error)
            })
    })
}

export const deleteStrategyTemplate = (args: { request: StrategyTemplateProto }): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = '/v2/strategy'
        api.request({
            url: url,
            headers: {
                Accept: 'application/x-protobuf'
            },
            method: 'DELETE',
            responseType: 'arraybuffer',
            data: args.request
        })
            .then(async (response) => {
                if(response.status===200) {
                    store.dispatch(removeStrategyTemplate(args.request?.id??''))
                    commonActions.setApiError(store.dispatch, { error: true, message: 'Template deleted successfully', errorType: 'success'})
                }
                resolve()
            })
            .catch((error) => {
                reject(error)
            })
    })
}